import { provideAppInitializer } from '@angular/core';

declare global {
  interface Window {
    __TAURI__?: unknown;
  }
}

/**
 * Checks for a desktop app update on startup (Tauri only) and installs it.
 */
export function provideDesktopUpdaterInitializer() {
  return provideAppInitializer(() => {
    if (typeof window === 'undefined' || window.__TAURI__ === undefined) {
      return;
    }

    return (async () => {
      try {
        const { check } = await import('@tauri-apps/plugin-updater');
        const { relaunch } = await import('@tauri-apps/plugin-process');

        const update = await check();
        if (!update) {
          return;
        }

        await update.downloadAndInstall();
        await relaunch();
      } catch (error) {
        console.warn('[desktop-updater] Update check failed', error);
      }
    })();
  });
}
